import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TimeOverviewBasePageRoutingModule } from './time-overview-base-routing.module';

import { TimeOverviewBasePage } from './time-overview-base.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    TimeOverviewBasePageRoutingModule
  ],
  declarations: [TimeOverviewBasePage]
})
export class TimeOverviewBasePageModule {}
